import { useMemo } from "react";

export enum SidebarIconsSrc {
  DASHBOARD = "/assets/images/icons/sidebar-home.svg",
  DEVICES = "/assets/images/icons/sidebar-products.svg",
  NOTIFICATIONS = "/assets/images/icons/sidebar-notifications.svg",
  ORDER = "/assets/images/icons/sidebar-order.svg",
  REQUEST_SERVICE = "/assets/images/icons/sidebar-request-service.svg",
  PROPERTIES = "/assets/images/icons/sidebar-properties.svg",
  USERS = "/assets/images/icons/sidebar-users.svg",
  ORGANIZATIONS = "/assets/images/icons/sidebar-organizations.svg",
  TIERS = "/assets/images/icons/sidebar-tiers.svg",
  GUIDES = "/assets/images/icons/sidebar-guides.svg",
  INTELLIGENCE = "/assets/images/icons/sidebar-search.svg",
  HANDOVER = "/assets/images/icons/sidebar-handover.svg",
  ADMIN = "/assets/images/icons/sidebar-gear.svg",
}

interface SidebarIconProps {
  icon: SidebarIconsSrc;
  isSelected?: boolean;
  showNotificationIcon?: boolean;
}

const SidebarIcon = (props: SidebarIconProps) => {
  const { icon, isSelected, showNotificationIcon } = props;

  const iconSrc = useMemo(() => {
    if (isSelected) {
      const selectedIcon = icon.replace(".svg", "-selected.svg");
      return selectedIcon;
    } else {
      return icon;
    }
  }, [icon, isSelected]);

  return (
    <div className={`sidebar-icon-container ${isSelected ? "selected" : ""}`}>
      <img src={process.env.PUBLIC_URL + iconSrc} />
      {showNotificationIcon && <span className="sidebar-notification-icon" />}
    </div>
  );
};

export default SidebarIcon;
